var _excluded = ["as", "children", "onClick", "before", "after", "className", "size", "theme", "loading", "href", "freeze", "disabled", "data-qa", "noRadiusLeft", "noRadiusRight", "mobile", "fullWidth", "isColorfulIcon", "outlined", "preventDefault"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { useCallback } from "react";
var getClassName = _ref => {
  var {
    size,
    theme,
    loading,
    href,
    className,
    noRadiusLeft,
    noRadiusRight,
    mobile,
    fullWidth,
    isColorfulIcon,
    outlined
  } = _ref;
  return ["glz-button", size && "glz-is-".concat(size), theme && theme !== "default" && "glz-is-".concat(theme), noRadiusLeft && "glz-no-radius-left", noRadiusRight && "glz-no-radius-right", loading && !href && "glz-is-loading", mobile && "glz-is-mobile", fullWidth && "glz-is-fullwidth", isColorfulIcon && "glz-is-colorfull-icon", outlined && "glz-is-outlined", className].filter(Boolean).join(" ");
};
var Button = props => {
  var {
      as = "button",
      children = "",
      onClick,
      before,
      after,
      className,
      size,
      theme = "default",
      loading,
      href,
      freeze,
      disabled,
      "data-qa": dataQa = "button",
      noRadiusLeft,
      noRadiusRight,
      mobile,
      fullWidth,
      isColorfulIcon,
      outlined,
      preventDefault = true
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var classNameProps = {
    size,
    theme,
    loading,
    href,
    className,
    disabled,
    noRadiusLeft,
    noRadiusRight,
    mobile,
    fullWidth,
    isColorfulIcon,
    outlined
  };
  var handleClick = useCallback(event => {
    if (onClick && !(loading || freeze || disabled)) {
      onClick(event);
    }
    if (preventDefault && !href) {
      event.preventDefault();
    }
    return false;
  }, [onClick, loading, freeze, disabled]);
  var beforeItem = !!before && /*#__PURE__*/React.createElement("span", {
    className: "glz-before-icon"
  }, before);
  var afterItem = !!after && /*#__PURE__*/React.createElement("span", {
    className: "glz-after-icon"
  }, after);
  var As = typeof as === "string" && as.length ? as : "button";
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(As, _extends({
      tabIndex: disabled || loading ? -1 : 0
    }, rest, {
      href: href,
      "data-qa": dataQa,
      className: getClassName(classNameProps),
      disabled: disabled,
      onClick: handleClick
    }), beforeItem, children, afterItem)
  );
};
export default Button;